.gy{border:1px solid #ddd;}